import { ParagraphNode, TextNode } from 'lexical';

function createFallbackNodeClass(type, elementType) {
  if (elementType === "inline") {
    class FallbackNode2 extends TextNode {
      static getType() {
        return type;
      }
      static clone(node) {
        return new FallbackNode2(node.__key);
      }
      static importJSON(serializedNode) {
        return TextNode.importJSON(serializedNode);
      }
      static importDOM() {
        return TextNode.importDOM();
      }
      exportJSON() {
        return super.exportJSON();
      }
    }
    return FallbackNode2;
  }
  class FallbackNode extends ParagraphNode {
    static getType() {
      return type;
    }
    static clone(node) {
      return new FallbackNode(node.__key);
    }
    static importJSON(serializedNode) {
      return ParagraphNode.importJSON(serializedNode);
    }
    static importDOM() {
      return ParagraphNode.importDOM();
    }
    exportJSON() {
      return super.exportJSON();
    }
  }
  return FallbackNode;
}

export { createFallbackNodeClass as default };
//# sourceMappingURL=factory.mjs.map
